import { render, staticRenderFns } from "./VPSRegistrationPage.vue?vue&type=template&id=576ba84f&scoped=true"
import script from "./VPSRegistrationPage.vue?vue&type=script&lang=js"
export * from "./VPSRegistrationPage.vue?vue&type=script&lang=js"
import style0 from "./VPSRegistrationPage.vue?vue&type=style&index=0&id=576ba84f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576ba84f",
  null
  
)

export default component.exports